import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { AvitoTaskState } from './state';

const defaultState: AvitoTaskState = {
  tasks: [],
};

export const avitoTaskModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
